import { createFileRoute } from '@tanstack/react-router';
import { RequireRole } from '../components/RequireRole';
import { UsersList } from '../features/users/UsersList';

export const Route = createFileRoute('/users/')({
  component: () => (
    <RequireRole
      allow={[
        'admin',
        'responsable_partenaire',
        'responsable_backoffice',
        'manager',
        'superviseur',
      ]}
    >
      <UsersList />
    </RequireRole>
  ),
});
